export const DragonflyMark: FC<{ size?: number; mono?: boolean }> = ({
  size = 28,
  mono = false,
}) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden>
    <title>Dragonfly</title>
    <ellipse
      cx="20"
      cy={mono ? 10 : 9}
      rx={mono ? 2.6 : 3.2}
      ry={mono ? 3.6 : 4.4}
      fill={mono ? "#fff" : "#0e9aa0"}
    />
    <rect
      x={mono ? 19 : 18.6}
      y={mono ? 12.5 : 12}
      width={mono ? 2 : 2.8}
      height={mono ? 15 : 20}
      rx={mono ? 1 : 1.4}
      fill={mono ? "#fff" : "#086068"}
      opacity={mono ? 0.9 : 1}
    />
    <path
      d={
        mono
          ? "M19 15 C12 10, 6 13, 6 16 C6 19, 12 18, 19 16.5 Z"
          : "M19 15 C10 9, 3 12, 3 16 C3 20, 11 19, 19 17 Z"
      }
      fill={mono ? "#fff" : "#19c4bb"}
      opacity={mono ? 0.85 : 0.9}
    />
    <path
      d={
        mono
          ? "M21 15 C28 10, 34 13, 34 16 C34 19, 28 18, 21 16.5 Z"
          : "M21 15 C30 9, 37 12, 37 16 C37 20, 29 19, 21 17 Z"
      }
      fill={mono ? "#fff" : "#19c4bb"}
      opacity={mono ? 0.85 : 0.9}
    />
    {!mono && (
      <>
        <path
          d="M19 18 C11 15, 5 18, 5 21 C5 24, 12 23, 19 21 Z"
          fill="#6a57cf"
          opacity="0.55"
        />
        <path
          d="M21 18 C29 15, 35 18, 35 21 C35 24, 28 23, 21 21 Z"
          fill="#6a57cf"
          opacity="0.55"
        />
      </>
    )}
  </svg>
);
